import React from 'react';
import InputField from '../../Forms/Input/InputField';
import SelectField from '../../Forms/Input/SelectField';
import DatePicker from '../../Forms/DatePicker/DatePicker';
import SimpleSearchSelect from '../../Forms/Input/SimpleSearchSelect';
import { PurchaseSummary } from '../../../types/purchases/BasePurchase';

interface Props {
  purchase: PurchaseSummary;
}

const PurchaseHeaderView: React.FC<Props> = ({ purchase }) => {
  const isImport = purchase.documentType?.id === 2;

  return (
    <div className="w-full rounded-sm border border-stroke bg-white p-6 shadow-default dark:border-strokedark dark:bg-boxdark">
      <div className="mb-6 grid gap-4 sm:grid-cols-2">
        <SelectField
          label="Tipo de Documento"
          name="documentType"
          iconKey="list"
          value={purchase.documentType.id}
          options={[{ value: purchase.documentType.id, label: purchase.documentType.name }]}
          onChange={() => {}}
          disabled
        />
        <InputField
          label="Número de Documento"
          name="documentNumber"
          iconKey="hash"
          value={purchase.documentNumber ?? ''}
          type="text"
          onChange={() => {}}
          disabled
        />
      </div>

      <div className="mb-6 grid gap-4 sm:grid-cols-2">
        <DatePicker
          label="Fecha de Compra"
          name="purchaseDate"
          iconKey='calendar'
          value={purchase.purchaseDate}
          onChange={() => {}}
          disabled
        />
        <SimpleSearchSelect
          label="Proveedor"
          name="supplier"
          iconKey="listOrdered"
          options={[{ id: purchase.supplier.id, name: purchase.supplier.name }]}
          selectedValue={purchase.supplier.id}
          onSelect={() => {}}
          disabled
        />
      </div>

      {isImport && (
        <div className="mb-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <InputField
            label="Total Monto Neto"
            name="netAmount"
            iconKey="dollar"
            type="number"
            value={(purchase as any).netAmount || ''}
            onChange={() => {}}
            disabled
          />
          <InputField
            label="Flete"
            name="freight"
            iconKey="truck"
            type="number"
            value={(purchase as any).freight || ''}
            onChange={() => {}}
            disabled
          />
          <InputField
            label="Seguro"
            name="insurance"
            iconKey="security"
            type="number"
            value={(purchase as any).insurance || ''}
            onChange={() => {}}
            disabled
          />
          <InputField
            label="FAUCA"
            name="fauca"
            iconKey="document"
            type="number"
            value={(purchase as any).fauca || ''}
            onChange={() => {}}
            disabled
          />
          <InputField
            label="Otros Costos"
            name="otherCosts"
            iconKey="more"
            type="number"
            value={(purchase as any).otherCosts || ''}
            onChange={() => {}}
            disabled
          />
        </div>
      )}
    </div>
  );
};

export default PurchaseHeaderView;
